export default (): {
    REACT_APP_BASE_URL: string;
} => {
    return {
        REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL || 'https://localhost:3333/v1/winner-promotion'
    }
}